import { NgZone } from '@angular/core';
import {
  CommandProgressStoreActions,
  DevicesOsUpdateStatusActions,
  DevicesRouterStoreSelectors,
  DeviceStoreActions,
} from '@era/stores';
import { Store } from '@ngrx/store';
import { CommandProgress, Device as MdmDevice, RequestType } from '@rocksoft/mdm-sdk-v2';
import { RouteGroupRule } from '@rocksoft/shared';
import { lastValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * Creates route group rules for the MDM hub
 */
export function createMdmRules(store: Store, zone: NgZone): RouteGroupRule[] {
  return [
    // MDM devices route - handles device changes
    {
      name: 'mdm-devices-group',
      urlPattern: /^\/mdm\/devices/,
      hub: 'mdm',
      groupName: 'mdm-devices',
      eventHandlers: [
        {
          eventName: 'OnDeviceAddedOrUpdatedAsync',
          handler: (device: MdmDevice) => {
            zone.run(() => {
              store.dispatch(DeviceStoreActions.DeviceSignalRHubActions.mdmDeviceChanged({ device }));
            });
          },
        },
        {
          eventName: 'OnDeviceRemovedAsync',
          handler: (device: MdmDevice) => {
            zone.run(() => {
              store.dispatch(DeviceStoreActions.DeviceSignalRHubActions.mdmDeviceRemoved({ device }));
            });
          },
        },
      ],
    },

    // MDM Apple device detail route - handles command progress
    {
      name: 'mdm-device-detail-group',
      urlPattern: /^\/mdm\/devices\/apple\/[^/]+/,
      hub: 'mdm',
      groupName: async (store) => {
        const udid = await lastValueFrom(store.select(DevicesRouterStoreSelectors.selectUdid).pipe(take(1)));
        if (!udid) return null;
        return `mdm-device_${udid}`;
      },
      eventHandlers: [
        {
          eventName: 'OnAppleCommandProgressAsync',
          handler: (commandProgress: CommandProgress) => {
            zone.run(() => {
              store.dispatch(
                CommandProgressStoreActions.CommandProgressSignalRActions.commandProgressReceived({ commandProgress })
              );
              if (commandProgress.requestType === RequestType.OsUpdateStatus) {
                store.dispatch(
                  DevicesOsUpdateStatusActions.SignalRActions.receivedOsUpdateStatusCommand({ commandProgress })
                );
              }
            });
          },
        },
      ],
    },
  ];
}
